import { setToken } from "./token.js";

// Dev-only — hits POST /auth/dev/session to mint an admin JWT from a plain
// merchantId. The endpoint 404s when NODE_ENV=production (auth-dev.controller),
// so this module can't accidentally escape staging/prod.
//
// A real embedded-Shopify build replaces this call with
// getSessionToken(appBridge) → POST /auth/session → JWT.
interface DevSessionResponse {
  data: { token: string; expiresIn: number; merchantId: string };
  meta: { correlationId: string | undefined };
}

export class DevSessionError extends Error {
  readonly status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function mintDevSession(merchantId: string): Promise<{
  merchantId: string;
  expiresAt: number;
}> {
  const res = await fetch("/auth/dev/session", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ merchantId }),
  });
  const text = await res.text();
  if (!res.ok) {
    let msg = res.statusText || "Failed to mint dev session";
    try {
      const parsed = JSON.parse(text) as { message?: string };
      if (parsed.message) msg = parsed.message;
    } catch {
      // fall through with statusText
    }
    throw new DevSessionError(msg, res.status);
  }
  const parsed = JSON.parse(text) as DevSessionResponse;
  const expiresAt = Date.now() + parsed.data.expiresIn * 1000;
  setToken({
    token: parsed.data.token,
    merchantId: parsed.data.merchantId,
    expiresAt,
  });
  return { merchantId: parsed.data.merchantId, expiresAt };
}
